// store/actions/user.actions.ts
import { createAction, props } from '@ngrx/store';
import { Role } from 'src/app/core/models/role.model';

export const loadRoles = createAction('[User] Load Roles');
export const loadRolesSuccess = createAction(
  '[User] Load Roles Success',
  props<{ roles: Role[] }>()
); 